import LZString from './lz-string.min'
import { isWeiXin } from "./open-download-app";
// 唤起支付
export function callPay(options) {
    const {
        payType,
        payInfo,
        redirectUrl // 支付完成跳转链接，需要是完整路径
    } = options
    if (payType === 'wxpayH5' && isWeiXin()) {
        // 微信里必须用微信公众号支付(jsapi)
        callWxJSAPIPay({
            // appId,
            // timeStamp,
            // nonceStr,
            // signType,
            // paySign,
            // package: prepayId
            ...payInfo,
            package: payInfo.prepayId
        }).then(() => {
            if (redirectUrl) {
                location.href = redirectUrl
            }
        })
    } else {
        callH5Pay(options)
    }
}


// 调用微信公众号支付(jsapi)
export function callWxJSAPIPay(params) {
    return new Promise((resolve, reject) => {
        const requestPay = () => {
            console.log('getBrandWCPayRequest:', params)
            window.WeixinJSBridge.invoke(
                "getBrandWCPayRequest",
                {
                    ...params,
                },
                (res) => {
                    // 使用以上方式判断前端返回,微信团队郑重提示：
                    // res.err_msg将在用户支付成功后返回 ok，但并不保证它绝对可靠。
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                        resolve(true)
                    } else {
                        reject()
                    }
                }
            );
        }
        if (typeof window.WeixinJSBridge === "undefined") {
            document.addEventListener(
                "WeixinJSBridgeReady",
                requestPay,
                false
            );
        } else {
            requestPay()
        }
    })
}

// 获取微信jsCode
export function getWxJsCode() {
    const matchCode = /code=([^&]+)/.exec(location.href)
    const jsCode = matchCode?.[1]
    console.log('jscode----', jsCode);
    if (!jsCode) {
        // 调用授权登录接口
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxea4ae255733cb575&redirect_uri=${encodeURIComponent(location.href)}&response_type=code&scope=snsapi_base&state=#wechat_redirect`
        return false
    } else {
        return jsCode
    }
}
// 唤起h5支付
export function callH5Pay({
    payType,
    payInfo,
    redirectUrl,
    ...otherParams
}) {
    const payInfoCompress = LZString.compressToBase64(JSON.stringify({
        ...payInfo,
    }))

    window.globalRouter.push({
        path: '/middlePageOfPay',
        query: {
            ...otherParams,
            info: payInfoCompress,
            // from: 'sameType',
            payType,
            redirectUrl: encodeURIComponent(redirectUrl)
        },
    });
}